/**
 * Do not edit directly, this file was auto-generated.
*/

import * as kicks_blackFriday from "autogen/theming/themes/kicks/blackFriday";
import * as kicks_campaign1 from "autogen/theming/themes/kicks/campaign1";
import * as kicks_campaign2 from "autogen/theming/themes/kicks/campaign2";
import * as kicks_campaign3 from "autogen/theming/themes/kicks/campaign3";
import * as kicks_christmas from "autogen/theming/themes/kicks/christmas";
import * as kicks_club1 from "autogen/theming/themes/kicks/club1";
import * as kicks_club2 from "autogen/theming/themes/kicks/club2";
import * as kicks_default from "autogen/theming/themes/kicks/default";
import * as kicks_neutral from "autogen/theming/themes/kicks/neutral";
import * as kicks_pharma from "autogen/theming/themes/kicks/pharma";
import * as kicks_sun from "autogen/theming/themes/kicks/sun";
import * as matas_blackFriday from "autogen/theming/themes/matas/blackFriday";
import * as matas_campaign1 from "autogen/theming/themes/matas/campaign1";
import * as matas_campaign2 from "autogen/theming/themes/matas/campaign2";
import * as matas_campaign3 from "autogen/theming/themes/matas/campaign3";
import * as matas_christmas from "autogen/theming/themes/matas/christmas";
import * as matas_club1 from "autogen/theming/themes/matas/club1";
import * as matas_club2 from "autogen/theming/themes/matas/club2";
import * as matas_default from "autogen/theming/themes/matas/default";
import * as matas_neutral from "autogen/theming/themes/matas/neutral";
import * as matas_pharma from "autogen/theming/themes/matas/pharma";
import * as matas_sun from "autogen/theming/themes/matas/sun";

const themeMap = {
  kicks: {
    blackFriday: kicks_blackFriday,
    campaign1: kicks_campaign1,
    campaign2: kicks_campaign2,
    campaign3: kicks_campaign3,
    christmas: kicks_christmas,
    club1: kicks_club1,
    club2: kicks_club2,
    default: kicks_default,
    neutral: kicks_neutral,
    pharma: kicks_pharma,
    sun: kicks_sun
  },
  matas: {
    blackFriday: matas_blackFriday,
    campaign1: matas_campaign1,
    campaign2: matas_campaign2,
    campaign3: matas_campaign3,
    christmas: matas_christmas,
    club1: matas_club1,
    club2: matas_club2,
    default: matas_default,
    neutral: matas_neutral,
    pharma: matas_pharma,
    sun: matas_sun
  }
};

export default themeMap;